module.exports = __webpack_public_path__ + "static/media/send.43cf729c.svg";